<template>
  <b-modal ref="modal-importa-aquivo" hide-footer title="Arquivo">
    <b-row>
      <b-col>
        <label for="file" class="mr-sm-2 font-weight-bolder mb-3 d-block">
          <i class="fa fa-upload mr-2"></i> Importar planilha e Entregas em
          massa
        </label>
        <div class="input-group">
          <div class="custom-file">
            <input
              accept=".xls, .csv, .xlsx"
              v-on:change="setFile()"
              ref="file"
              type="file"
              class="custom-file-input"
              id="inputGroupFile01"
            />
            <label class="custom-file-label" for="inputGroupFile01">
              {{ fileName }}
            </label>
          </div>
        </div>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col class="text-right">
        <b-button size="sm" variant="danger" @click="hideModal">
          Fechar
        </b-button>
        <b-button
          variant="info"
          @click="importOrders"
          :disabled="!file || loadingButton"
          size="sm"
        >
          {{ loadingButton ? "Carregando..." : "Enviar" }}
          <i class="fa fa-play ml-2"></i>
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import barramento from "../../../../barramento";
import swal from "sweetalert2";
import axios from "axios";
export default {
  data() {
    return {
      action: null,
      only_filtered: false,
      exportSelected: "csv",
      exportSelected2: "csv",
      email: null,
      file: null,
      type: "all",
      fileName: "Selecione",
      compactPdf: false,
      loadingButton: false,
    };
  },
  beforeDestroy() {
    barramento.$off("modal-import-aquivo");
  },
  created() {
    barramento.$on("modal-import-aquivo", () => {
      this.showModal();
    });
  },
  methods: {
    showModal() {
      this.$refs["modal-importa-aquivo"].show();
    },
    hideModal() {
      this.$refs["modal-importa-aquivo"].hide();
    },
    setFile() {
      if (
        this.$refs &&
        this.$refs.file &&
        this.$refs.file.files &&
        this.$refs.file.files[0]
      ) {
        this.file = this.$refs.file.files[0];
        this.fileName = `${this.file.name.substr(0, 7)}...`;
      }
    },
    clearFile() {
      this.file = null;
      this.fileName = null;
      this.hideModal();
      barramento.$emit("log-import-loading", true);
    },
    importOrders() {
      this.loadingButton = true;
      let formData = new FormData();
      formData.append("sheet", this.file);
      axios
        .post("/api/orders/import", formData)
        .then((success) => {
          swal({
            title: this.$t("Pronto!"),
            text: this.$t(
              "Seu arquivo já foi incluido para importação, em breve você podera vê-lo em seu painel."
            ),
            type: "success",
          });
          this.loadingButton = false;
          this.clearFile();
        })
        .catch((error) => {
          console.log(error);
          
          swal({
            title: "Ops!",
            text: this.$t(
              "Não foi possivel processar seu arquivo, tente novamente em alguns instantes."
            ),
            type: "error",
          });
          this.loadingButton = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/Importacao/ModalImportaArquivo.vue